import { connect } from 'react-redux';

import StatisticsTopBar from '@/components/StatisticsTopBar';
import { updateFilters } from '@/features/usersStatisticsPage/actions';
import {
  MAX_STATISTICS_DATE,
  MIN_STATISTICS_DATE,
} from '@/features/usersStatisticsPage/consts/dates';
import { getFilters } from '@/features/usersStatisticsPage/selectors';
import stats from '@/features/usersStatisticsPage/stats';

const mapStateToProps = state => ({
  filters: getFilters(state),
  stats,
  minDate: MIN_STATISTICS_DATE,
  maxDate: MAX_STATISTICS_DATE,
});

const mapDispatchToProps = { updateFilters };

export default connect(mapStateToProps, mapDispatchToProps)(StatisticsTopBar);
